import wedding_card from "../../assets/wedding-card.png";
import GoogleMap from "../../components/Map";
import "./styles.scss";
import Audio from "../../components/Audio";
import FormCard from "../../components/FormCard";
import Footer from "../../components/Footer";
import background_music from "../../assets/background-music.mp3";

function Card() {
  return (
    <div className="card">
      <div className="container-lg">
        <div className="card-animation">
          <div className="card-container">
            <Audio src={background_music} />
            <img
              className="card-img"
              src={wedding_card}
              alt="Invitation Henné"
            />
            <GoogleMap query="Synagogue Beth Chalom, 79 Boulevard de Verdun, 94120 Fontenay-Sous-Bois" />
            <FormCard types={{ henne: "Henné" }} type="Henne" />
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
